export function simulateClick (arg) {
  let btn = document.createElement('a')
  btn.style.display = 'none'
  btn.href = arg
  document.body.appendChild(btn)
  btn.click()
  document.body.removeChild(btn)
}



// WEBPACK FOOTER //
// ./src/components/shared/helper/simulateClick.js